import { useTokens } from '../shared/theme';
import CupMark from '../shared/CupMark';
import InstitutionMark from '../shared/InstitutionMark.jsx';
import { marketingHomeUrl } from './portalUrl.js';

/**
 * Shared full-viewport, centered layout for the portal's pre-shell states
 * (find-your-school, outage, disabled, loading). Warm cream page, a quiet cup
 * mark up top, content centered in a narrow column. Every
 * state reads as part of the same product.
 *
 * @param {{ children: React.ReactNode, institution?: Object|null }} props
 */
export default function StateScreen({ children, institution }) {
  const t = useTokens();
  const schoolName = institution?.branding?.displayName || institution?.name;
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center"
      style={{ backgroundColor: t.page, color: t.body, fontFamily: t.fonts.body }}
    >
      <div className="w-full max-w-[720px] px-6 pt-8 flex items-center justify-between gap-5">
        <a
          href={marketingHomeUrl()}
          aria-label="Coffee Chats home"
          className={`shrink-0 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${t.focusRing}`}
        >
          {/* Phones drop the wordmark: beside a school chip the two labels collide. */}
          <span className="hidden sm:inline-flex"><CupMark size={48} wordmarkSize={28} withWordmark /></span>
          <span className="sm:hidden"><CupMark size={44} /></span>
        </a>
        {institution ? (
          <InstitutionMark
            name={schoolName}
            slug={institution.slug}
            logoFileId={institution.branding?.logoFileId}
            logoSource={institution.branding?.logoSource}
            autoLogoDomain={institution.branding?.autoLogoDomain}
            size={42}
            showName
          />
        ) : null}
      </div>
      <div className="flex-1 w-full max-w-[560px] px-6 flex flex-col justify-center pb-20">
        {children}
      </div>
    </div>
  );
}
